import PropTypes from 'prop-types';
import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {AccountApplication} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    // Optional: the Add page has no record yet (FNP-946).

    record?: Omit<AccountApplication, 'id'>,
    handleSubmit: (values: AccountApplication) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: AccountApplication) => {
        handleSubmit(values);
        navigate('/account-applications');
    };

    const onCancel = () => {
        navigate('/account-applications');
    };


    let initialValues = {} as AccountApplication;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest} />
                </FormWithButtons>)}
        </Formik>
    );
};

RecordForm.propTypes = {
    record: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
};
